import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCryptopunk: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"cryptopunk,nft,pfp,profile,avatar"} maskId="square-filled-radius-0-stroke-1-IconCryptopunk"><path fillRule="evenodd" clipRule="evenodd" d="M6 2H18V3H6V2ZM6 6V3H5V9H4V14H5V22H11V20H18V19H19V7H22V6H19V3H18V6H6ZM10.99 9H12.01V10H10.99V9ZM14.99 9H16V10H14.99V9ZM9.99 14H11V15H9.99V14ZM11 15H16V16H11V15Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCryptopunk;
